import { ReactNode } from 'react'
import { Column } from './FlexContainer'
import { FolderIcon } from '../inline-svg'
import PrimeIcon from './PrimeIcon'
import ClassNameBuilder from '../../../tools/ClassNameBuilder'
import t from '../../../tools/t'

interface MessageScreenProps {
    title?: string
    message?: string
    delay?: boolean
}

interface GraphicMessageScreenProps extends MessageScreenProps {
    graphic?: ReactNode
}

export default function MessageScreen({
    graphic,
    title,
    message,
    delay,
}: GraphicMessageScreenProps) {
    const classNames = new ClassNameBuilder()
        .add('message-screen')
        .addIf('message-screen--delay', delay)
    return (
        <Column arrangement="center" alignment="center" className={classNames.toString()}>
            <div className="message-screen__graphic">{graphic}</div>
            <div className="message-screen__title">{title}</div>
            <div className="message-screen__detail">{message}</div>
        </Column>
    )
}

interface LayeredIconMessageScreenProps extends MessageScreenProps {
    iconName?: PrimeIconName
    iconSize?: number
}
export const LayeredIconMessageScreen = ({
    iconName = 'exclamation-triangle',
    iconSize = 128,
    delay = true,
    ...props
}: LayeredIconMessageScreenProps) => (
    <MessageScreen
        {...props}
        delay={delay}
        graphic={
            <div className="message-screen__layered-icon">
                <PrimeIcon
                    className="message-screen__layered-icon-shadow"
                    name={iconName}
                    size={iconSize}
                />
                <PrimeIcon
                    className="message-screen__layered-icon-top"
                    name={iconName}
                    size={iconSize}
                />
            </div>
        }
    />
)

export const EmptyMessageScreen = (props: MessageScreenProps) => (
    <MessageScreen {...props} graphic={<FolderIcon />} />
)

export const ErrorMessageScreen = ({
    title = t('common_error'),
    message = t('system_unknown_error'),
    ...props
}: MessageScreenProps) => <LayeredIconMessageScreen {...props} title={title} message={message} />
